import { AccordionDetails, Box, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import BriaAccordion from "../../../common/BriaAccordion/BriaAccordion";
import styles from "./McpServerFaqSection.module.scss";
import { getMcpFaqs, handleAnswerLinkClick } from "./McpServerFaqs";

const McpServerFaqSection: React.FC = () => {
	const { t } = useTranslation("translation", { keyPrefix: "mcpServer.faqSection" });
	const faqItems = getMcpFaqs(t);

	return (
		<Box className={styles.faqSection}>
			<Typography className={styles.faqTitle}>{t("faqTitle")}</Typography>

			{faqItems.map((item, index) => (
				<BriaAccordion
					key={index}
					className={styles.accordion}
					accordionTitle={item.question}
					useSecondaryIcons
				>
					<AccordionDetails>
						{item.answer.map((ans, i) => {
							switch (ans.type) {
								case "text":
								case "paragraph":
									return (
										<Typography key={i} className={styles.accordionDetails}>
											{ans.content}
										</Typography>
									);

								case "paragraphWithListAndLink":
									return (
										<>
											<Typography key={`intro-${i}`} className={styles.accordionDetails}>
												{ans.intro}
											</Typography>
											<ul className={styles.serviceList} key={`list-${i}`}>
												{ans.list.map((li, j) => (
													<li key={j} className={styles.serviceListItem}>
														{li}
													</li>
												))}
											</ul>
											<Typography key={`midText-${i}`} className={styles.accordionDetails}>
												{ans.midText}
											</Typography>
											<Typography key={`outro-${i}`} className={styles.accordionDetails}>
												<Typography
													component="a"
													onClick={() => handleAnswerLinkClick(ans.linkId)}
													className={styles.linkUrl}
												>
													{ans.linkText}
												</Typography>
												{" " + ans.outro}
											</Typography>
										</>
									);

								default:
									return null;
							}
						})}
					</AccordionDetails>
				</BriaAccordion>
			))}
		</Box>
	);
};

export default McpServerFaqSection;
